import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { BasisAccessRulesKeyEnum } from './basis-access-rules-key.enum';
import { BasisAccessRulesConst } from './basis-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class BasisAccessService extends BaseAccessService<BasisAccessRulesKeyEnum> {
  public constructor() {
    super(BasisAccessRulesConst);
  }

  // --- Рабочий стол ---
  public get dashboardRights() {
    return {
      canWriteDashboardTemplate: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_DASHBOARD_TEMPLATE_WRITE]
      )
    };
  }

  // --- Компании ---
  public get companyRights() {
    return {
      canWriteCompany: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_COMPANY_WRITE]
      ),
      canWriteCompanyGroup: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_COMPANY_GROUP_WRITE]
      ),
      canWriteCompanyErp1C: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_COMPANY_ERP_1C_WRITE]
      )
    };
  }

  public get companyPermissions() {
    return {
      canAccessToAllCompanies: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_COMPANY_ACCESS_TO_ALL_COMPANIES]
      )
    };
  }

  // --- Клиенты ---
  public get clientRights() {
    return {
      canWriteClient: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CLIENT_WRITE]
      ),
      canWriteContragent: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CLIENT_CONTRAGENT_WRITE]
      ),
      canWriteContract: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CLIENT_CONTRACT_WRITE]
      ),
      canWriteExternalUser: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CLIENT_EXTERNAL_USER_WRITE]
      ),
      canWriteBanner: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CLIENT_BANNER_WRITE]
      )
    };
  }

  public get clientPermissions() {
    return {
      canDeleteClients: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CLIENT_CAN_DELETE_CLIENTS]
      )
    };
  }

  // --- Пользователи ---
  public get securityRights() {
    return {
      canWriteGroup: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_GROUP_WRITE]
      ),
      canReadRole: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_ROLE_READ]
      ),
      canWriteRole: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_ROLE_WRITE]
      ),
      canReadUser: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_READ]
      ),
      canWriteUser: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_WRITE]
      ),
      canReadWorkSchedule: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_WORK_SCHEDULE_READ]
      ),
      canWriteWorkSchedule: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_WORK_SCHEDULE_WRITE]
      )
    };
  }

  public get securityPermissions() {
    return {
      canBanUser: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_CAN_BAN_USER]
      ),
      canUserAccessToList: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_ACCESS_TO_LIST]
      ),
      canGroupAccessToList: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SECURITY_GROUP_ACCESS_TO_LIST]
      )
    };
  }

  // --- Справочники ---
  public get catalogRights() {
    return {
      canWriteDirection: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_DIRECTION_WRITE]
      ),
      canWriteUnit: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_UNIT_WRITE]
      ),
      canWriteFilial: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_FILIAL_WRITE]
      ),
      canWriteRoom: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_ROOM_WRITE]
      ),
      canWriteDocumentType: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_DOCUMENT_TYPE_WRITE]
      ),
      canWriteOperationType: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_OPERATION_TYPE_WRITE]
      ),
      canWriteMasterMilestone: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_MASTER_MILESTONE_WRITE]
      ),
      canWriteApprovalScheme: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_APPROVAL_SCHEME_WRITE]
      ),
      canWriteNomenclature: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_NOMENCLATURE_WRITE]
      ),
      canWriteCostCenter: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_COST_CENTER_WRITE]
      ),
      canWriteAccountingAccount: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_ACCOUNTING_ACCOUNT_WRITE]
      ),
      canWriteAi: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_AI_WRITE]
      ),
      canWriteWebhook: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_WEBHOOK_WRITE]
      ),
      canWriteDocumentFileTemplate: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE_WRITE]
      )
    };
  }

  public get catalogPermissions() {
    return {
      canAccessAllApprovalSchemes: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_APPROVAL_SCHEME_ACCESS_ALL]
      ),
      canAccessAllDirections: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_CATALOG_ACCESS_TO_ALL_DIRECTIONS]
      )
    };
  }

  // --- Админ панель ---
  public get systemRights() {
    return {
      canWriteBudgetClassificationCode: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SYSTEM_BUDGET_CLASSIFICATION_CODE_WRITE]
      ),
      canWriteChangelog: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SYSTEM_CHANGELOG_WRITE]
      ),
      canWriteCurrency: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SYSTEM_CURRENCY_WRITE]
      ),
      canWritePayerStatus: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SYSTEM_PAYER_STATUS_WRITE]
      ),
      canWritePlugin1C: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SYSTEM_PLUGIN_1C_WRITE]
      ),
      canWriteRatePlan: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SYSTEM_RATE_PLAN_WRITE]
      ),
      canWriteTenant: this.globalService.isAccessRule(
        BasisAccessRulesConst[BasisAccessRulesKeyEnum.BASIS_SYSTEM_TENANT_WRITE]
      )
    };
  }
}
